import React from "react";
import Overview from "./Overview";
import Add from "./Add";
import Edit from "./Edit";
import { PositionProvider } from "../../../context/PositionContext";

export const Arts = () => {
  return (
    <PositionProvider>
      <Overview />
    </PositionProvider>
  );
};

export const AddArt = () => {
  return (
    <Add />
  );
};

export const EditArt = () => {
  return (
    <Edit />
  );
};
